import { useCallback, useEffect, useRef } from 'react';

const useHandleClickOutside = (handleOnClickOutside: () => void) => {
  const contentRef = useRef<HTMLDivElement>();

  const handleClickedOutside = useCallback(
    (event: MouseEvent) => {
      if (
        contentRef.current &&
        !contentRef.current?.contains(event.target as Node)
      ) {
        handleOnClickOutside();
      }
    },
    [contentRef, handleOnClickOutside],
  );

  useEffect(() => {
    window.document.addEventListener('click', handleClickedOutside, true);

    return () => {
      window.document.removeEventListener('click', handleClickedOutside, true);
    };
  }, [handleClickedOutside]);

  return { contentRef };
};

export default useHandleClickOutside;
